<crm-multi-select
  [filtersUiVersion]="filtersUiVersion"
  [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
  [class]="class + (isError ? ' ng-invalid ng-dirty' : '')"
  [label]="isFloatLabel ? 'Помещение' : ''"
  [showClear]="showClear"
  [appendTo]="appendTo"
  [options]="rooms"
  [disabled]="disabled"
  [display]="display"
  [sort]="sort"
  [placeholder]="placeholder"
  [(selectedItems)]="selectedRooms"
  (selectedItemsChange)="onSelectedRoomsChange($event)"
  [loading]="loading || selectionLoading"></crm-multi-select>
